import styled from "styled-components";
import { Toggle } from "discover.medical.react-component-library";

export const StyledToggleButton = styled(Toggle.Button)`
  text-transform: none;
`;
